import React from "react";
import Dollars from "../../../common/typeFormatting/Dollars";
import Decimal from "../../../common/typeFormatting/DecimalFmt";

const RevenueTypeSection = ({revenueSection}) => {

    return (
        <>
            <thead style={{position: "sticky", top: 0}}>
                <tr>
                    <th colSpan={8}>{revenueSection.revenueType}</th>
                </tr>
                <tr>
                    <th>Account</th>
                    <th className="text-right">Start Hours</th>
                    <th className="text-right">Hours Earned</th>
                    <th className="text-right">Hours Used</th>
                    <th className="text-right">$ Earned</th>
                    <th className="text-right">$ Used</th>
                    <th className="text-right">Hours Avail.</th>
                    <th className="text-right">Cash Avail.</th>
                </tr>
            </thead>
            <tbody>
                {revenueSection.subaccountTotals.length > 0
                ?
                <>
                    {revenueSection.subaccountTotals.map((d,index) =>
                        <tr key={index}>
                            <td>{d.subaccount}</td>
                            <td className="text-right"><Decimal>{d.prevHoursBalance}</Decimal></td>
                            <td className="text-right"><Decimal>{d.hoursEarned}</Decimal></td>
                            <td className="text-right"><Decimal>{d.hoursUsed}</Decimal></td>
                            <td className="text-right"><Dollars>{d.cashEarned}</Dollars></td>
                            <td className="text-right"><Dollars>{d.cashUsed}</Dollars></td>
                            <td className="text-right"><Decimal>{d.hoursAvailable}</Decimal></td>
                            <td className="text-right"><Dollars>{d.cashAvailable}</Dollars></td>
                        </tr>                   
                    )}
                    <tr>
                        <td>Total</td>
                        <td className="text-right"><Decimal>{revenueSection.totals.startHours}</Decimal></td>
                        <td className="text-right"><Decimal>{revenueSection.totals.earnedHours}</Decimal></td>
                        <td className="text-right"><Decimal>{revenueSection.totals.usedHours}</Decimal></td>
                        <td className="text-right"><Dollars>{revenueSection.totals.earnedDollars}</Dollars></td>
                        <td className="text-right"><Dollars>{revenueSection.totals.usedDollars}</Dollars></td>
                        <td className="text-right"><Decimal>{revenueSection.totals.hoursAvailable}</Decimal></td>
                        <td className="text-right"><Dollars>{revenueSection.totals.cashAvailable}</Dollars></td>
                    </tr>                
                </>
                :
                <tr><td colSpan={8}>No data found.</td></tr>
            }                  
            </tbody>                     
        </>

    );

}

export default RevenueTypeSection;